import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "@jti/ui";
import styles from "../SingleError.module.scss";
export const OutOfStockItems = ({ items, variant = "regular", className }) => {
    const { __: translate } = useTranslations();
    if (items.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: className, children: [_jsx("p", { className: classNames(styles.title, { [styles.titleRegular]: variant === "regular" }), children: translate("cart.items.out_of_stock_message_box.title") }), variant === "regular" ? (_jsxs("div", { className: styles.messageContainer, children: [_jsx("p", { children: translate("cart.items.out_of_stock_message_box.intro") }), _jsx("ul", { className: styles.productsList, children: items.map((item) => {
                            const name = "name" in item ? item.name : undefined;
                            const label = "label" in item ? item.label : undefined;
                            return (_jsx("li", { children: _jsx("p", { className: styles.name, children: name || label }) }, name || label));
                        }) }), _jsx("p", { children: translate("cart.items.out_of_stock_message_box.proceedText") })] })) : null] }));
};
//# sourceMappingURL=OutOfStockItems.js.map